import { Core, CoreContext, useRbSystemAlert } from '@scmlatam/web-ui';
import { useCore } from '../hooks/core/useCore';
import { useTranslation } from 'react-i18next';
import { useContext, useEffect } from 'react';
import { PermissionsChangedNotice } from "../components/notice/PermissionsChangedNotice";

const Layout = ({ msalInstance }: { msalInstance: any }) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation('core.sidebar');
  const { showAlert } = useRbSystemAlert();
  const coreProps = useCore();

  const { setFormat, setSingleShortcut, setRangeShortcut } = useContext(CoreContext);

  useEffect(() => {
    const onForbidden = () => showAlert('error', t('alerts.forbidden'));

    window.addEventListener('authorization:forbidden', onForbidden);

    return () => {
      window.removeEventListener('authorization:forbidden', onForbidden);
    };
  }, [showAlert, t]);

  useEffect(() => {
    setFormat(coreProps.dateFormat);
    setSingleShortcut(coreProps.singleShortcuts);
    setRangeShortcut(coreProps.rangeShortcuts);

    console.log('language', i18n.language);
  }, [i18n.language]);

  return (
    <>
      <Core {...coreProps} msalInstance={msalInstance} />
      <PermissionsChangedNotice />
    </>
  );
};

export { Layout };
